module.exports = __webpack_public_path__ + "static/31-6be43930d1616581398934f8e92b4868.jpg";